import { render, staticRenderFns } from "./ReferenceTable.vue?vue&type=template&id=23ea0a10"
import script from "./ReferenceTable.vue?vue&type=script&lang=js"
export * from "./ReferenceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports